import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { service } from "@ember/service";
import { eq } from "discourse/truth-helpers";
import { i18n } from "discourse-i18n";

export default class CommunityFeedbackGameFilter extends Component {
  @service communityNavigation;

  get games() {
    const remoteGames = new Map(
      this.communityNavigation.games.map((game) => [game.key, game])
    );

    return (this.args.games || []).map((game) => ({
      ...game,
      icon_url: remoteGames.get(game.key)?.icon_url,
    }));
  }

  <template>
    <div
      class="community-feedback-games"
      role="group"
      aria-label={{i18n "community_feedback.game_filter"}}
    >
      <button
        type="button"
        class="community-feedback-games__item"
        aria-pressed={{if (eq @selected "all") "true" "false"}}
        {{on "click" (fn @onSelect "all")}}
      >
        <span class="community-feedback-games__all-icon" aria-hidden="true"></span>
        <span class="community-feedback-games__name">
          {{i18n "community_feedback.filters.all_games"}}
        </span>
      </button>

      {{#each this.games as |game|}}
        <button
          type="button"
          class="community-feedback-games__item"
          aria-pressed={{if (eq @selected game.key) "true" "false"}}
          {{on "click" (fn @onSelect game.key)}}
        >
          <span class="community-feedback-games__icon-wrap">
            {{#if game.icon_url}}
              <img
                class="community-feedback-games__icon"
                src={{game.icon_url}}
                alt=""
                loading="lazy"
              />
            {{/if}}
          </span>
          <span class="community-feedback-games__name">{{game.name}}</span>
        </button>
      {{/each}}
    </div>
  </template>
}
